import type { OnlyFansMessage } from '@api'
import { format } from 'date-fns'

import type { Message } from '@/modules/chatting/types.ts'

export const hasNonEmptyMedia = (message?: OnlyFansMessage) => {
  return !!message?.media?.length && !!message.media[0].files.thumb?.url
}

export const prepareMessage = (message: OnlyFansMessage): Message => ({
  ...message,
  sentDate: message.createdAt
    ? format(new Date(message.createdAt), 'dd MM yyyy')
    : format(new Date(), 'dd MM yyyy'),
})
